export const GroupCategoriesMap = {
  consultant: 'Consultant',
  customer: 'Customer',
  sponsor: 'Sponsor',
  favorite: 'Favorites',
  accepted: 'Accepted',
  pending: 'Pending'
} as const

export enum TypePeriod {
  disable,
  day,
  week,
  month
}
